import "../Css/Fairepart.css";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from "./CheckoutForm";


const stripePromise = loadStripe('pk_test_51RCfMoPOWtkOA3g6ln5uBoeFNXQLAM4xpGnMYRx4tzDaU8OhT4HXNT008WaDGmvyu5gvhEsjCIhOueynjytrBSh200eFq4Hqdl');

export default function Cagnotte() {


  return (
    
    <div id="Cagnotte" className='cagnotte-container'>
        <div className="section-title">
            <div className="title">Lune de miel</div>
            <div className="swirls">
              <img className="swirls-img" alt="" src="./Images/Icons/swirl_left.png"></img>
              <img className="swirls-img" alt="" src="./Images/Icons/swirl.png"></img>
            </div>
          </div>
          <div className="cagnotte-content">
          <div>
              <h1>Stripe Payment Example</h1>
              {/* Wrap the CheckoutForm component with the Elements component and provide the Stripe promise */}
              <Elements stripe={stripePromise}>
                <CheckoutForm />
              </Elements>
            </div>
          </div>

    </div>
    
  );
}